import DOMPurify from 'dompurify';
import { SelectionV1 } from 'src/projects/types/Selection';
import { readSearchParam } from 'src/common/readSearchParam.ts';
import { LOCATION_STORE_PARAM_NAME } from 'src/common/constants.ts';

type Props = {
    selection: SelectionV1;
};

// Read-only display of the comment saved with the selection (locationState.checkoutComment).
export const ProjectSelectionComment = ({ selection }: Props) => {
    const { checkoutComment } = readSearchParam<{ checkoutComment: string }>(
        new URLSearchParams(selection.searchQuery),
        LOCATION_STORE_PARAM_NAME,
        { checkoutComment: '' },
        (value): value is object => typeof value === 'object' && value !== null,
    );

    const comment = checkoutComment?.trim();
    if (!comment) {
        return null;
    }

    return (
        <div className="vss-project-selection-item__comment">
            {DOMPurify.sanitize(comment)}
        </div>
    );
};
